export const REQUEST_SUCCESS = 'CCM.API_REQUEST_SUCCESS'
export const REQUEST_REJECTED = 'CCM.API_REQUEST_REJECTED'
export const REQUEST_PENDING = 'CCM.API_REQUEST_PENDING'
